import * as PropTypes from 'prop-types';

export interface Props {
  filterChangedCallback: () => void;
  // tslint:disable-next-line:no-any
  valueGetter: (params: any) => any;
}

export const propTypes = {
    filterChangedCallback: PropTypes.func.isRequired,
    valueGetter: PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/filters/boolean/props.ts